import api from '@/libs/api'
import store from '@/store'

const getProjectId = () => store.state.app.projectId

const environment = 'snitch'

export default {
  namespaced: true,
  state: {
    serviceUnavailable: false,
    serviceRequested: false,
    fetchingAlerts: false,
    gettingAlert: false,
    currentPage: 1,
    alertsResultInfo: {},
    alerts: [],
    alert: {},
    addingAlert: false,
    updatingAlert: false,
    removingAlert: false,
  },
  getters: {
    currentPage: state => state.currentPage,
  },
  mutations: {
    SET_SERVICE_UNAVAILABLE(state, value) {
      state.serviceUnavailable = true
      state.serviceRequested = value
    },
    SET_FETCHING_ALERTS(state, value) {
      state.fetchingAlerts = value
    },
    SET_ALERTS(state, value) {
      state.alerts = value.result
      state.alertsResultInfo = value.resultInfo
    },
    GET_ALERT(state, value) {
      state.alert = value
    },
    SET_ADDING_ALERT(state, value) {
      state.addingAlert = value
    },
    SET_GETTING_ALERT(state, value) {
      state.gettingAlert = value
    },
    SET_CURRENT_PAGE(state, value) {
      state.currentPage = value
    },
    REMOVE_ALERT(state, id) {
      state.alerts = state.alerts.filter(h => h.id !== id)
    },
    SET_UPDATING_ALERT(state, value) {
      state.updatingAlert = value
    },
    SET_REMOVING_ALERT(state, value) {
      state.removingAlert = value
    },
  },
  actions: {
    fetchAlerts({ commit }, query) {
      commit('SET_FETCHING_ALERTS', true)
      return new Promise((resolve, reject) => {
        api(environment).get(`projects/${getProjectId()}/alerts?PageIndex=${query.pageIndex}&PageSize=${query.pageSize}`)
          .then(response => {
            commit('SET_ALERTS', response.data)
            resolve(response)
          })
          .catch(error => {
            if (error.response?.status === 426 || error.response?.status === 428) {
              commit('SET_SERVICE_UNAVAILABLE', error.response?.status === 428)
            }
            reject(error)
          })
          .finally(() => { commit('SET_FETCHING_ALERTS', false) })
      })
    },
    getAlert({ commit }, alertId) {
      commit('SET_GETTING_ALERT', true)
      return new Promise((resolve, reject) => {
        api(environment).get(`projects/${getProjectId()}/alerts/${alertId}`)
          .then(response => {
            commit('GET_ALERT', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_GETTING_ALERT', false) })
      })
    },
    addAlert({ commit }, query) {
      commit('SET_ADDING_ALERT', true)
      return new Promise((resolve, reject) => {
        api(environment).post(`/projects/${getProjectId()}/alerts/`, query.alert)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_ADDING_ALERT', false) })
      })
    },
    updateAlert({ commit }, query) {
      commit('SET_UPDATING_ALERT', true)
      return new Promise((resolve, reject) => {
        api(environment).put(`/projects/${getProjectId()}/alerts/${query.id}`, query.alert)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_UPDATING_ALERT', false) })
      })
    },
    removeAlert({ commit }, alertId) {
      commit('SET_REMOVING_ALERT', true)
      return new Promise((resolve, reject) => {
        api(environment).delete(`/projects/${getProjectId()}/alerts/${alertId}`)
          .then(response => {
            commit('REMOVE_ALERT', alertId)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_REMOVING_ALERT', false) })
      })
    },
  },
}
